// Columns backed by record props rather than fields: owner, who created the record, created and updated dates; the pipeline of a stage.

import { formatDate, type FieldDef, type Id, type MetaIndex, type RecordObj } from '@confdeck/core-shared';
import { TermChips, UserValue } from '../fields/FieldValue.tsx';
import { pipelineSectionOf } from '../pipelines/pipeline-section.ts';

export const SYSTEM_COLUMNS: Record<string, { label: string; icon: string }> = {
  ownerId: { label: 'Ответственный', icon: 'user' },
  createdBy: { label: 'Создал', icon: 'user' },
  createdAt: { label: 'Создано', icon: 'date' },
  updatedAt: { label: 'Изменено', icon: 'date' },
};

const PIPELINE = ':pipeline';
/**
 * The pipeline of a stage field, a column of its own (`stage:pipeline`, R-U29: «Все сделки» show «Воронка» and «Этап»): the stage the
 * record stands on is a child of its pipeline. Named by the section's word («Категория» of tasks), «Воронка» otherwise.
 */
export function pipelineColumn(meta: MetaIndex, typeId: Id, key: string): { label: string; icon: string; base: FieldDef } | undefined {
  if (!key.endsWith(PIPELINE)) return undefined;
  const base = meta.field(typeId, key.slice(0, -PIPELINE.length));
  if (!base || base.archivedAt || base.fieldType !== 'taxonomy' || meta.taxonomy(base.options.taxonomyId as Id)?.style !== 'pipeline') return undefined;
  return { label: pipelineSectionOf(meta.type(typeId)?.key)?.words.pipeline ?? 'Воронка', icon: 'board', base };
}
const pipelineOf = (meta: MetaIndex, v: unknown) => { const t = meta.term(String(Array.isArray(v) ? v[0] : v)); return t?.parentId ?? null; };

export function systemValue(key: string, rec: RecordObj, meta: MetaIndex) {
  const p = pipelineColumn(meta, rec.typeId, key);
  if (p) return <TermChips ids={pipelineOf(meta, rec.data[p.base.key])} />;
  if (key === 'ownerId') return <UserValue id={rec.ownerId} />;
  if (key === 'createdBy') return <UserValue id={rec.createdBy} />;
  if (key === 'createdAt') return <span className="muted">{formatDate(rec.createdAt)}</span>;
  if (key === 'updatedAt') return <span className="muted">{formatDate(rec.updatedAt)}</span>;
  return null;
}
